import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

// ---------------------------------------------------------

import Container from '@layout/container';
import Layout from '@layout/index';
import RadioButton from '@components/radio-button';

// ---------------------------------------------------------

import { wrapper, states_container, earnest_money_iframe } from './styles.module.scss';

// ---------------------------------------------------------

const EarnestPage = () => {
  const router = useRouter();
  const [selectedState, setSelectedState] = useState();

  useEffect(() => {
    if (!router.isReady) return;

    if (router.query.state) {
      setSelectedState(router.query.state);
    } else {
      setSelectedState();
    }
  }, [router.isReady, router.query.state]);

  const selectStateAndUpdateQuery = (el) => {
    setSelectedState(el);

    router.push(
      {
        pathname: '/earnest',
        query: { state: el }
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <Layout>
      {!selectedState && (
        <Container spacing="large" gridOptions={{ layout: 'single' }}>
          <div className={wrapper}>
            <div>
              <h1>Earnest Money Payment</h1>
              <p>Choose the state of the property below to make your payment online.</p>
            </div>
            <div className={states_container}>
              <RadioButton
                items={[
                  {
                    icon: 'ohio',
                    label: 'Ohio',
                    value: 'ohio'
                  },
                  {
                    icon: 'kentucky',
                    label: 'Kentucky',
                    value: 'kentucky'
                  },
                  {
                    icon: 'indiana',
                    label: 'Indiana',
                    value: 'indiana'
                  }
                ]}
                theme="with-icon"
                groupName="state"
                onChange={(el) => {
                  if (!Array.isArray(el)) {
                    selectStateAndUpdateQuery(el);
                  }
                }}
              ></RadioButton>
            </div>
          </div>
        </Container>
      )}

      {selectedState === 'ohio' && (
        <iframe
          className={earnest_money_iframe}
          title="Ohio Earnest Money Payment"
          frameBorder="0"
          src="https://app.payload.co/payment-links/3c7nc2FCawN4gAZ2OqOgC?client_key_3c7nc2F7qC3APmxALaGc0"
        ></iframe>
      )}
      {selectedState === 'kentucky' && (
        <iframe
          className={earnest_money_iframe}
          title="Kentucky Earnest Money Payment"
          frameBorder="0"
          src="https://app.payload.co/payment-links/3c7nfw9ppIN03lRuF6RBI?client_key_3c7nfw9lAYBvZ3Od33m7V"
        ></iframe>
      )}
      {selectedState === 'indiana' && (
        <iframe
          className={earnest_money_iframe}
          title="Indiana Earnest Money Payment"
          frameBorder="0"
          src="https://app.payload.co/payment-links/3c7ngTyAyi193uDOOkHKg?client_key_3c7ngTy6bh5SicLAc7rmX"
        ></iframe>
      )}
    </Layout>
  );
};

export default EarnestPage;
